/**
 * Wordmark — ported from the OnFlow Design System project
 * (components/core/Wordmark.jsx).
 *
 * There is no logo mark anywhere in the product — the wordmark IS the
 * identity. Never draw one.
 */
import type { CSSProperties, ElementType } from 'react';

interface WordmarkProps {
  size?: number;
  color?: string;
  accentColor?: string;
  as?: ElementType;
  style?: CSSProperties;
}

export function Wordmark({ size = 22, color, accentColor, as = 'span', style }: WordmarkProps) {
  const Tag = as;
  return (
    <Tag
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 500,
        fontSize: size,
        letterSpacing: size >= 48 ? '-0.04em' : '-0.01em',
        lineHeight: 1,
        color: color || 'var(--on-background)',
        ...style,
      }}
    >
      OnFlow
      <span style={{ color: accentColor || 'var(--primary)' }}>.</span>
    </Tag>
  );
}
